<template functional>
  <svg :class="[data.class, data.staticClass, 'stella-icon']" :style="data.staticStyle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="props.filled" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6ZM12 20C9.5 20 7.29 18.92 5.8 17.2C5.76 15.17 9.8 14.1 12 14.1C14.19 14.1 18.24 15.17 18.2 17.2C16.71 18.92 14.5 20 12 20Z" fill="currentColor"/>
    <path v-else d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 4C16.41 4 20 7.59 20 12C20 13.88 19.35 15.61 18.25 16.98C17.84 15.53 15.34 14.5 12 14.5C8.66 14.5 6.16 15.53 5.75 16.98C4.65 15.61 4 13.88 4 12C4 7.59 7.59 4 12 4ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 18.5C13.97 18.5 15.74 17.8 17.07 16.63C16.4 15.77 14.73 15.3 12 15.3C9.27 15.3 7.6 15.77 6.93 16.63C8.26 17.8 10.03 18.5 12 18.5Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconProfile",
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
